import { AVATAR_GROUP } from "./constants.js";
const pt = {
    [AVATAR_GROUP]: {
        MEMBERS: 'Miembros'
    }
};
export { pt };
